import axios, { parseCursor } from '@/base/api/axios'
import { underscorizeKeys } from '@/utils/utils'

export default {

  async create (agreement) {
    return (await axios.post('/api/agreements/', agreement)).data
  },

  async get (agreementId) {
    return (await axios.get(`/api/agreements/${agreementId}/`)).data
  },

  async list (params = {}) {
    const response = (await axios.get('/api/agreements/', { params: underscorizeKeys(params) })).data
    return {
      ...response,
      next: parseCursor(response.next),
      results: response.results,
    }
  },

  async save (agreement) {
    return (await axios.patch(`/api/agreements/${agreement.id}/`, agreement)).data
  },
}
